import { render } from "./CourseRequestContent.vue?vue&type=template&id=213d18f6&scoped=true"
import script from "./CourseRequestContent.vue?vue&type=script&lang=js"
export * from "./CourseRequestContent.vue?vue&type=script&lang=js"

import "./CourseRequestContent.vue?vue&type=style&index=0&id=213d18f6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213d18f6"]])

export default __exports__